import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import type { AppState } from '~/store/app.store';
import type {
  BoundaryGroupId, BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';
import { activeBoundaryTerritoryGroupsSelector } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import { dataLayersFiltersStateToBoundaryFilters } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.helpers';
import type { DataLayersFiltersState } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.state';

export const activeDataLayersBTGIdPerBoundaryGroupToolsStateSelector = (state: AppState): Record<BoundaryGroupId, BoundaryTerritoryGroupId> => {
  return state.map.mapSettings.data.toolsState.dataLayers.activeBTGIdPerBoundaryGroup;
};

export const dataLayersFiltersStateSelector = (state: AppState): DataLayersFiltersState =>
  state.map.mapSettings.data.toolsState.dataLayers.filters;

export const dataLayersFiltersSelector = createStateSelector([
  dataLayersFiltersStateSelector,
  (state: AppState) => activeBoundaryTerritoryGroupsSelector(state, true),
], dataLayersFiltersStateToBoundaryFilters);

export const useDataLayersFilters = () => useSelector(dataLayersFiltersSelector);
